// extracted by mini-css-extract-plugin
export default {"typeRow":"UnitsList__typeRow___KaoZo","removeButton":"UnitsList__removeButton___Rqe2w"};